// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';
import { TCatalogItems, TCatalogItemsCollections, TCatalogNextTraining, TCatalogWeapons } from '../../types';

const initialState: IRootState = {
  next_training: [] as TCatalogNextTraining[],
  items: {} as TCatalogItems,
  weapons: {} as TCatalogWeapons,
  items_collections: {} as TCatalogItemsCollections,
};

export const slice = createSlice({
  name: STORE_SLICES.CATALOG_DATA,
  initialState,
  reducers,
});

const catalogDataActions = slice.actions;

const catalogDataPersistConfig = {
  key: PERSIST_KEYS.CATALOG_DATA,
  storage,
  whitelist: ['next_training', 'items', 'items_collections'],
};

export { catalogDataActions, initialState };
export default persistReducer(catalogDataPersistConfig, slice.reducer);
